module.exports = __webpack_public_path__ + "img/info@3x.0b49da5f.png";